// extracted by mini-css-extract-plugin
export default {"sideBarContainer":"wc_OzwKw","collapse":"K2aurKJZ","closedCollapse":"rSxpZpzj","sideBar":"W2LdaFcC","collapseSmallScreen":"i0n3gDXJ","icon":"_jzusf_H"};